module.exports = __webpack_public_path__ + "img/amg.7e55301d.png";